import React from 'react';
import { mountOn } from './lib/mount';
import { readEmbedded } from './lib/embedded';
import { AppEditor } from './components/app_editor';

function EditorRoot() {
  const el = document.getElementById('editor-root');
  const doc = readEmbedded('editor-data');
  const documentUrl = el?.dataset.documentUrl;

  if (!doc) return <div className="docs-empty"><div className="docs-empty-title">Failed to load document</div></div>;
  return <AppEditor document={doc} documentUrl={documentUrl} />;
}

mountOn('editor-root', <EditorRoot />);
